import { t } from 'i18next';

import { DataTableColumn } from 'components/dataTable';

import { PwcOrderStatus } from 'types/pwcOrder';

export const KEYS = {
  FILTER_KEY: 'pwcOrders',
  ITEMS_PER_PAGE_OPTIONS: [15, 20, 50, 100],
  SEARCH_DEBOUNCE_TIMEOUT: 700,
  DATE_FORMAT: 'MMM DD, HH:mm A',
  CRYPTO_SYMBOL_SEPARATOR: '.',
  CRYPTO_NETWORK_SPACING_SYMBOLS_EXP: /[_]/gi,
};

export const filterStatusGroups = {
  initiated: [PwcOrderStatus.Initiated],
  pending: [PwcOrderStatus.Pending],
  submitted: [PwcOrderStatus.Submitted],
  confirmed: [PwcOrderStatus.Confirmed],
  completed: [PwcOrderStatus.Completed],
  incomplete: [PwcOrderStatus.Incomplete],
  overpaid: [PwcOrderStatus.Overpaid],
  expired: [PwcOrderStatus.Expired],
  canceled: [PwcOrderStatus.Canceled],
  declined: [PwcOrderStatus.Declined],
  failed: [PwcOrderStatus.Failed],
  refunded: [PwcOrderStatus.Refunded],
  partialRefund: [PwcOrderStatus.PartialRefund],
};

export const LABELS = {
  BREADCRUMBS: [['page.pwcOrders.breadcrumbs', 'Charges']],
  PAGE_TITLE: ['page.pwcOrders.list.title', 'Order list'],
  SEARCH_PLACEHOLDER_S4USER: [
    'page.pwcOrders.list.search.placeholderS4User',
    'Search by Order ID, Ext Order ID, User or Account ID, User Email',
  ],
  SEARCH_PLACEHOLDER_PARTNER: ['page.pwcOrders.list.search.placeholderPartner', 'Search by Order ID, Ext Order ID, User Email'],
  CSV_DOWNLOAD_ERROR: ['page.pwcOrders.list.csv.downloadError', 'Something went wrong, please try again later'],
  CSV_FILE_NAME: ['page.pwcOrders.list.csv.fileName', 'Orders export {{date}}.csv'],
  EXPORT_MODAL_TITLE: ['page.pwcOrders.list.export.modalTitle', 'Export Order List'],
  FILTERS: {
    STATUS: {
      LABEL: ['page.pwcOrders.list.filter.status.label', 'Status'],
      INITIATED: ['page.pwcOrders.list.filter.status.initiated', 'Initiated'],
      PENDING: ['page.pwcOrders.list.filter.status.pending', 'Pending'],
      SUBMITTED: ['page.pwcOrders.list.filter.status.submitted', 'Submitted'],
      CONFIRMED: ['page.pwcOrders.list.filter.status.completed', 'Confirmed'],
      COMPLETED: ['page.pwcOrders.list.filter.status.completed', 'Completed'],
      INCOMPLETE: ['page.pwcOrders.list.filter.status.incomplete', 'Incomplete'],
      OVERPAID: ['page.pwcOrders.list.filter.status.overpaid', 'Overpaid'],
      EXPIRED: ['page.pwcOrders.list.filter.status.expired', 'Expired'],
      CANCELED: ['page.pwcOrders.list.filter.status.canceled', 'Canceled'],
      DECLINED: ['page.pwcOrders.list.filter.status.declined', 'Declined'],
      FAILED: ['page.pwcOrders.list.filter.status.failed', 'Failed'],
      REFUND_INITIATED: ['page.pwcOrders.list.filter.status.refundInitiated', 'Refund Initiated'],
      REFUND_SUBMITTED: ['page.pwcOrders.list.filter.status.refundSubmitted', 'Refund Submitted'],
      REFUND_FAILED: ['page.pwcOrders.list.filter.status.refundFailed', 'Refund Failed'],
      REFUNDED: ['page.pwcOrders.list.filter.status.refunded', 'Refunded'],
      PARTIAL_REFUND: ['page.pwcOrders.list.filter.status.partialRefund', 'Partial Refund'],
    },
    LOCKED: {
      LABEL: ['page.account.list.filter.locked.label', 'Locked'],
      YES: ['page.account.list.filter.locked.yes', 'Yes'],
      NO: ['page.account.list.filter.locked.no', 'No'],
    },
    DATE: {
      LABEL: ['page.pwcOrders.list.filter.date.label', 'Date'],
    },
    FIAT_CURRENCY: {
      LABEL: ['page.pwcOrders.list.filter.fiatCurrency.label', 'Fiat Currency'],
    },
    ORDER_AMOUNT: {
      LABEL: ['page.pwcOrders.list.filter.orderAmount.label', 'Order Amount'],
    },
    MERCHANT: {
      LABEL: ['page.pwcOrders.list.filter.merchant.label', 'Merchant Account'],
      PLACEHOLDER: ['page.pwcOrders.list.filter.merchant.placeholder', 'Select one'],
    },
  },
  TABLE_COLUMNS: {
    STATUS: ['page.pwcOrders.list.table.columns.status', 'Status'],
    ID: ['page.pwcOrders.list.table.columns.id', 'Order ID'],
    DATE: ['page.pwcOrders.list.table.columns.date', 'Date'],
    CUSTOMER: ['page.pwcOrders.list.table.columns.customer', 'Customer'],
    ORDER_AMOUNT: ['page.pwcOrders.list.table.columns.orderAmount', 'Order Amount'],
    PAID_AMOUNT: ['page.pwcOrders.list.table.columns.paidAmount', 'Paid Amount'],
    LOCKED: ['page.pwcOrders.list.table.columns.locked', 'Locked'],
    ACTIONS: ['page.pwcOrders.list.table.columns.actions', ''],
  },
};

export const COLUMN_IDS = {
  STATUS: 'status',
  ID: 'uuid',
  DATE: 'createdAt',
  CUSTOMER: 'customerEmail',
  ORDER_AMOUNT: 'fiatAmount',
  FIAT_CURRENCY: 'fiatCurrencyCode',
  PAID_AMOUNT: 'paidFiatAmount',
  LOCKED: 'locked',
  ACTIONS: 'actions',
};

export const COLUMNS: DataTableColumn[] = [
  { id: COLUMN_IDS.STATUS, label: t(LABELS.TABLE_COLUMNS.STATUS) },
  { id: COLUMN_IDS.ID, label: t(LABELS.TABLE_COLUMNS.ID), sortable: true },
  { id: COLUMN_IDS.DATE, label: t(LABELS.TABLE_COLUMNS.DATE), sortable: true },
  { id: COLUMN_IDS.CUSTOMER, label: t(LABELS.TABLE_COLUMNS.CUSTOMER) },
  { id: COLUMN_IDS.ORDER_AMOUNT, label: t(LABELS.TABLE_COLUMNS.ORDER_AMOUNT) },
  { id: COLUMN_IDS.PAID_AMOUNT, label: t(LABELS.TABLE_COLUMNS.PAID_AMOUNT) },
  { id: COLUMN_IDS.LOCKED, label: t(LABELS.TABLE_COLUMNS.LOCKED), hidden: true },
  { id: COLUMN_IDS.ACTIONS, label: t(LABELS.TABLE_COLUMNS.ACTIONS) },
];
